import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import TeacherInfoService from "../service/teacherInfo";
import HttpClient from "../network/http";
import { fetchCsrfToken, useAuthContext } from "../context/AuthContext";

const baseURL = process.env.REACT_APP_BASE_URL;

export default function useTeacherInfo(conditions) {
  //location.path로 학교 아이디, role은 파람으로 모든 정보 가져오기
  const queryClient = useQueryClient();
  const { address } = useAuthContext();
  const httpClient = new HttpClient(baseURL, () => fetchCsrfToken(), address);
  const teacherInfoService = new TeacherInfoService(httpClient);

  //users db에서 teacherinfo join해서 가져온다.
  const teacherInfoQuery = useQuery(
    ["teacherInfo", conditions || ""],
    () =>
      teacherInfoService.findAllTeacherInfoWithRegiInfoBySchoolid(conditions),
    {
      // onSuccess: (success) => {
      //   console.log("success", success);
      // },
      enabled: !!conditions?.schoolid,
      staleTime: 1000 * 60 * 2, //2분,
    }
  );

  const findTeacherInfo = useMutation(
    (teacherInfo) => teacherInfoService.findTeacherInfo(teacherInfo),
    {
      onError: (error) => {
        // Handle the failure by displaying an error message or performing other actions
        console.error("Error teacherInfo 가져오는 중:", error);
        alert(error);
        // Add your error handling logic here
      },
    }
  );

  const updateTeacherInfo = useMutation(
    (teacherInfo) => teacherInfoService.updateTeacherInfo(teacherInfo),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["teacherInfo"]);
      },
      onError: (error) => {
        // Handle the failure by displaying an error message or performing other actions
        console.error("Error updating teacherInfo:", error);
        alert(error);
        // Add your error handling logic here
      },
    }
  );

  const createTeacherInfo = useMutation(
    (teacherInfo) => teacherInfoService.createTeacherInfo(teacherInfo),
    {
      onSuccess: () => queryClient.invalidateQueries(["teacherInfo"]),
      onError: (error) => {
        console.error("Error creating:", error);
      },
    }
  );

  const bulkTeacherInfo = useMutation(
    (bulkData) => teacherInfoService.bulkTeacherInfo(bulkData),
    {
      onSuccess: (result) => {
        // users + teacherinfos 두 테이블을 업데이트하므로 둘 다 무효화
        queryClient.invalidateQueries(["teacherInfo"]);
        queryClient.invalidateQueries(["usersConditions"]);
        return result; // 결과를 반환해서 onUploadComplete에서 사용할 수 있게 함
      },
      onError: (error) => {
        console.error("Error bulk uploading teacherInfo:", error);
        throw error; // 에러를 다시 throw해서 handleUpload에서 catch할 수 있게 함
      },
    }
  );

  return {
    teacherInfoQuery,
    updateTeacherInfo,
    createTeacherInfo,
    findTeacherInfo,
    bulkTeacherInfo,
  };
}
